import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import { httpsCallable } from 'firebase/functions';
import { firebaseFunctions } from '../../config/firebaseFunctions';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UnfollowDialog(props) {
  const router = useRouter();

  const [loading, setloading] = useState(false);

  const handleClose = () => {
    props.setdialogState(false);
  };

  const unfollow = async (e) => {
    setloading(true);
    setTimeout(() => {
      let modifiedArr = [...props.followingArtistsIds];
      let index = modifiedArr.indexOf(props.artistId);
      if (index !== -1) {
        modifiedArr.splice(index, 1);
      }
      props.setfollowingArtistsIds(modifiedArr);
      if (props.onSuccessUnFollowCallback) {
        props.onSuccessUnFollowCallback();
      }

      setloading(false);
      handleClose();
    }, 600);
    try {
      let followArtistAPI = httpsCallable(
        firebaseFunctions,
        'musicartFollowArtist',
      );

      let res = await followArtistAPI({
        artistId: props.artistId,
        follow: false,
      });
      // console.log("res", res);
    } catch (err) {
      // console.log("err", err);

      setloading(false);
      toast.error('An error occured!', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: {
          borderRadius: 20,
          width: 380,
        },
      }}
      disableScrollLock={false}
      style={{ zIndex: 999 }}
      maxWidth="sm"
      onClose={handleClose}
    >
      <div>
        <div className="dialog-titlebar">
          <div className="dialog-close">
            <button
              className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
              type="button"
              onClick={handleClose}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div>
          <DialogContent>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <div
                className="author__avatar"
                style={{ margin: 0, width: 100, height: 100 }}
              >
                <img
                  src={props.img ? props.img : '/img/unknow.jpg'}
                  alt="profile_image"
                />
              </div>
            </div>
            <div>
              <p className="text-black text-base font-medium mb-2 text-center mt-3">
                Unfollow @{props.artistName}?
              </p>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              justifyContent: 'center',
              boxSizing: 'border-box',
              textAlign: 'center',
            }}
          >
            <div className="w-full px-4 mb-4">
              <button
                className="dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full"
                type="button"
                onClick={unfollow}
                disabled={loading}
              >
                {loading ? (
                  <div className="flex justify-center	">
                    <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                  </div>
                ) : (
                  'Unfollow'
                )}
              </button>

              <button
                className="dialog__btn dialog__btn--white py-3 my-2 rounded-full hover:outline-none focus:outline-none ease-linear w-full"
                type="button"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </DialogActions>
        </div>
      </div>
    </Dialog>
  );
}
